import { useCallback, useEffect } from 'react';
import useUserManagementStore from '../stores/userManagementStore';

/**
 * PRX-116 T4 — how a component names a role: the label from GET /roles
 * (loaded once, shared through the store), "No role" when there is none, and
 * the raw key for a role the catalogue does not have, so an unknown role is
 * visible rather than renamed. Never format the role key itself.
 */
export function useRoleLabel(): (role: string | null | undefined) => string {
  const availableRoles = useUserManagementStore((s) => s.availableRoles);
  const ensureRoleCatalogue = useUserManagementStore((s) => s.ensureRoleCatalogue);

  useEffect(() => {
    void ensureRoleCatalogue();
  }, [ensureRoleCatalogue]);

  return useCallback(
    (role) => {
      if (!role) return 'No role';
      return availableRoles.find((r) => r.role === role)?.label ?? role;
    },
    [availableRoles],
  );
}
